import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { format } from "date-fns";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILogin } from "../../../models/Login";
import { Publish } from "../../requirement/Publish";
import { safeFormatDate } from "../../../models/DateFormatMapper";


interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    salEffFilter: any,
    salesID?: number,
    resType: number,
    catID?: number,
    branchID?: number,
    recType?: string,
    totalRec?: boolean | null
}

export const SubTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ sn: number }>, loading: boolean });
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const dt = useRef<any>(null);
    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });
    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        let filterQuery = "";
        if (props.catID)
            filterQuery += `&catID=${props?.catID}`;
        if (props.branchID)
            filterQuery += `&branchID=${props.branchID}`;

        if (props.recType) {
            filterQuery += `&recType=${props?.recType}`;
        }
        if (props.totalRec === true) {
            filterQuery += `&totalRec=${props?.totalRec}`;
        }

        const response = await Fetch("BranchLatencyReport/report", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const subDate = (rowData: { subDate: Date }) => {
        let date;
        if (rowData.subDate) date = format(new Date(rowData.subDate), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const downloadResume = async (path: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${path}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const consultant_Name = (rowData: { consultant_Name: string, consultant_Resume_Path: string }) => <span onClick={() => downloadResume(rowData.consultant_Resume_Path)}
        className="cursor-pointer text-cyan-700 underline">{rowData.consultant_Name}</span>

    const onHide = () => {
        props.hideDialog();
    }

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center" >
            <h5 className="m-0" >Recruiter Submission Report</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {/* <Column field="req_ID" header="Req.ID" sortable /> */}
                <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} />
                <Column field="sales_Person_Name" header="Sales Manager" />
                <Column field="salesBranchName" header="Sales Branch Name" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="recruiterBranchName" header="Recruiter Branch Name" />

                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />
                <Column field="req_EndClient" header="End Client" />
                {!((_role.includes(3) || _role.includes(4) || _role.includes(34) || _role.includes(40))) && <Column field="vendor_Company_Name" header="Prime Vendor" />}
                <Column field="subVendor" header="Sub Vendor" />
                {/* <Column field="subDate" header="Sub Date" body={subDate} /> */}
                <Column field="subDate" header="Sub Date" body={(rowData : any) => safeFormatDate(rowData.subDate, 'dd/MM/yyyy', DateFormat, true)} />
                <Column field="latency" header="Latency(Minutes)" />
                <Column field="status_Name" header="Status" />
                <Column field="comments" header="Comment" />
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />

        </Dialog>
    );
}